import { render, staticRenderFns } from "./ShipmentBatchCreate.vue?vue&type=template&id=40959620&scoped=true&"
import script from "./ShipmentBatchCreate.vue?vue&type=script&lang=js&"
export * from "./ShipmentBatchCreate.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentBatchCreate.vue?vue&type=style&index=0&id=40959620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40959620",
  null
  
)

export default component.exports